var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 8C12.8 7.1176 12.0824 6.4 11.2 6.4H10.4V4C10.4 1.7944 8.6056 0 6.4 0C4.1944 0 2.4 1.7944 2.4 4V6.4H1.6C0.7176 6.4 0 7.1176 0 8V14.4C0 15.2824 0.7176 16 1.6 16H11.2C12.0824 16 12.8 15.2824 12.8 14.4V8ZM4 4C4 2.6768 5.0768 1.6 6.4 1.6C7.7232 1.6 8.8 2.6768 8.8 4V6.4H4V4Z",
    fill: "#FC7D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7563a1a9fac328cabc0e8a5b2d84e495.svg";
export { ForwardRef as ReactComponent };